import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ShieldCheckIcon, ZapIcon, MailIcon } from 'lucide-react';
export function Precios() {
  return <section id="precios" className="py-20 md:py-28 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 relative overflow-hidden" data-id="element-102">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-103">
        <div className="absolute top-20 -right-20 w-60 h-60 bg-gold-500/10 rounded-full blur-3xl" data-id="element-104" />
        <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-burgundy-800/20 rounded-full blur-3xl" data-id="element-105" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-107">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-108">
            Oferta <span className="text-gold-400" data-id="element-109">Especial</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300" data-id="element-110">
            Accedé hoy al pack completo con un descuento exclusivo
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-111">
          {/* Header */}
          <div className="bg-gradient-to-r from-gold-500 to-gold-600 px-8 py-6 text-center" data-id="element-112">
            <h3 className="text-2xl md:text-3xl font-black text-navy-900" data-id="element-113">
              MEGA PACK COMPLETO
            </h3>
            <p className="text-navy-800 font-medium mt-1" data-id="element-114">
              13 Tomos - Primaria y Secundaria
            </p>
          </div>

          {/* Content */}
          <div className="p-8 md:p-12" data-id="element-115">
            {/* Features */}
            <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-116">
              <div className="flex items-start gap-3" data-id="element-117">
                <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-118" />
                <span className="text-gray-700" data-id="element-119">
                  13 Tomos (Primaria 1-7 y Secundaria 8-13)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-120">
                <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-121" />
                <span className="text-gray-700" data-id="element-122">
                  350+ páginas de contenido puro
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-123">
                <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-124" />
                <span className="text-gray-700" data-id="element-125">
                  Proyectos de escritura y análisis
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-126">
                <MailIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-127" />
                <span className="text-gray-700" data-id="element-128">
                  Acceso inmediato por correo
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-129">
                <ZapIcon className="h-6 w-6 text-gold-500 flex-shrink-0" data-id="element-130" />
                <span className="text-gray-700" data-id="element-131">
                  3 Bonos exclusivos incluidos
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-132">
                <ShieldCheckIcon className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-133" />
                <span className="text-gray-700" data-id="element-134">
                  Garantía de satisfacción de 7 días
                </span>
              </div>
            </div>

            {/* Price */}
            <div className="text-center mb-8" data-id="element-135">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-136">
                <span className="text-2xl text-gray-400 line-through" data-id="element-137">
                  $49.990 ARS
                </span>
                <span className="bg-red-100 text-red-600 text-sm font-bold px-3 py-1 rounded-full" data-id="element-138">
                  -60% OFF
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-139">
                <span className="text-5xl md:text-6xl font-black text-navy-900" data-id="element-140">
                  $19.990
                </span>
                <span className="text-xl text-gray-500" data-id="element-141">ARS</span>
              </div>
              <p className="text-gray-500 mt-2" data-id="element-142">
                Pago único - Acceso de por vida
              </p>
            </div>

            {/* CTA Button */}
            <a href="https://www.profepack.com/cart/48097187004672:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-navy-900 font-bold text-xl py-5 rounded-xl text-center shadow-lg shadow-gold-500/25 hover:shadow-gold-500/40 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-143">
              SÍ, QUIERO ESTA OFERTA
            </a>

            {/* Payment badge */}
            <div className="flex items-center justify-center gap-2 mt-6 text-gray-500 text-sm" data-id="element-144">
              <ShieldCheckIcon className="h-5 w-5" data-id="element-145" />
              <span data-id="element-146">Pago seguro con Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}